<template>
    <div class="container-fluid myCards">
        <navTopbar></navTopbar>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <h2 class="page-title"><i class="fas fa-cog"></i> {{ lang.sc_setting_title }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="list-group list-group-flush">
                            <h4
                                style="
                                    color: #9c9c9c;
                                    margin-top: 30px;
                                    font-weight: normal;
                                    font-size: 20px;
                                "
                            >
                                {{ lang.sc_setting_smart_card }}
                            </h4>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('orgUrl')"
                            >
                                {{ lang.sc_setting_org_info }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="list-group list-group-flush">
                            <h4
                                style="
                                    color: #9c9c9c;
                                    margin-top: 30px;
                                    font-weight: normal;
                                    font-size: 20px;
                                "
                            >
                                {{ lang.sc_setting_form_popup }}
                            </h4>
                            <!-- <router-link
                                :to="{ name: 'listForms' }"
                                class="list-group-item list-group-item-action"
                                >List of Forms
                            </router-link> -->
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('fnotiEmail')"
                            >
                                {{ lang.sc_setting_email_noti }}
                            </div>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('fnotiSms')"
                            >
                                {{ lang.sc_setting_sms_noti }}
                            </div>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('autoresponder')"
                            >
                                {{ lang.sc_setting_autoresponder }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- modal popup-->
        <modal name="modal-setting" height="auto" @before-close="ClosedModal">
            <div class="card">
                <button @click="closeModal" class="closeIcon"><span></span></button>
                <component :is="SettingBox"></component>
            </div>
        </modal>
        <!-- modal lateral-->
        <modalLateral>
            <component v-bind:is="m.component" ></component>
        </modalLateral>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader.vue";
import fnotiEmail from "@/apps/Marketea/components/bSite/setting/notiForm.vue";
import autoresponder from "@/apps/Marketea/components/bSite/setting/autoResponder.vue";
import fnotiSms from "@/apps/Marketea/components/notiSmsForm.vue";
import modalLateral from '@/core/plugins/themeModalLateral/modalLateral'
import orgUrl from '@/apps/Marketea/components/bSite/orgUrl'
import navTopbar from "@/apps/Marketea/components/bSite/navTopbar.vue";
import { mapGetters } from "vuex";
import './index.scss';
export default {
    components: {
        Loader,
        fnotiSms,
        fnotiEmail,
        autoresponder,
        modalLateral,
        orgUrl,
        navTopbar
    },
    data() {
        return {
            SettingBox: "",
            m: {
                show: false,
                component: '',
                data: []
            },
            lang: {
                sc_setting_title: '',
                sc_setting_smart_card: '',
                sc_setting_org_info: '',
                sc_setting_form_popup: '',
                sc_setting_email_noti: '',
                sc_setting_sms_noti: '',
                sc_setting_autoresponder: '',
            },
        };
    },
    created() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
    },
    methods: {
        editOptions(num) {
            let t = this;
            t.m.show= true;
            t.m.component= 'SettingLeads';
            if(num == 0){t.m.data= { opts: 0 };}
            if(num == 1){t.m.data= { opts: 1 };}
            if(num == 2){t.m.data= { opts: 2 };}
            if(num == 3){t.m.data= { opts: 3 };}
            this.$store.commit('core/setOpenModal', t.m);
        },
        ModalBox(i) {
            this.SettingBox = i;
            this.$modal.show("modal-setting");
        },
        closeModal() {
            this.$modal.hide("modal-setting");
        },
        ClosedModal() {
            this.SettingBox = "";
        },
        resfresh(res) {
            console.log(res.open);
            if (res.open == 1) {
                this.ClosedModal();
                this.closeModal();
            }
        },
    },
    watch: {
        get_settupStorage: function () {
            if (this.get_settupStorage) {
                let g = this.$store.getters["ModApps/Marketea/get_settupStorage"];
                let fun = g[0].function;
                let r = g[0].data[0];
                if (fun == "Noti") {
                    this.resfresh(r);
                }
            }
        },
        SettingBox: function () {
            if (!this.SettingBox == "") {
                this.$modal.show("modal-setting");
            }
        },
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea", ["get_settupStorage"]),
        ...mapGetters("ModApps/Marketea", { langGetter: "lang" }),
    },
};
</script>
